import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';

import { TOLL_ENDPOINT } from '../../config/endpoints';
import { TOLL_PATH } from '../../config/paths';

import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_DELETE_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';

import { isErrorResponse } from '../../utils/error-handlers';

import {
  FLAG_GETTING_TOLLS,
  GET_TOLLS,
  CLEAR_TOLLS,
  FLAG_TOLL_ACTIVITY,
  GET_TOLL,
  CLEAR_TOLL,
} from '../types';

const flagGettingTolls = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_TOLLS,
    payload: flag,
  });

const getTolls =
  (tableFilters = {}) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingTolls(true));

      const queryString = QueryString.stringify(tableFilters);
      const url = queryString
        ? `${TOLL_ENDPOINT}?${queryString}`
        : TOLL_ENDPOINT;

      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const tolls = await response.json();

      dispatch({
        type: GET_TOLLS,
        payload: tolls,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingTolls(false));
    }
  };

const clearTolls = () => (dispatch) =>
  dispatch({
    type: CLEAR_TOLLS,
  });

const flagTollActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_TOLL_ACTIVITY,
    payload: flag,
  });

const getToll =
  ({ tollId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollActivity(true));

      const url = `${TOLL_ENDPOINT}/${tollId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const toll = await response.json();

      dispatch({
        type: GET_TOLL,
        payload: toll,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollActivity(false));
    }
  };

const clearToll = () => (dispatch) =>
  dispatch({
    type: CLEAR_TOLL,
  });

const createNewToll = async ({
  name,
  description,
  addressId,
  locationId,
  pricePerAxle,
  taxPrePaymentPerAxle,
  electronic,
  electronicPricePerAxle,
  electronicTaxPrePaymentPerAxle,
  isExtraordinary,
  provia,
  businessId
}) => {
  const payload = {
    name,
    description,
    addressId,
    locationId,
    pricePerAxle,
    taxPrePaymentPerAxle,
    electronic,
    electronicPricePerAxle,
    electronicTaxPrePaymentPerAxle,
    isExtraordinary,
    provia,
    businessId
  };

  const response = await fetch(TOLL_ENDPOINT, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });

  await isErrorResponse(response);

  return response.json();
};

const postToll =
  ({
    name,
    description,
    addressId,
    locationId,
    pricePerAxle,
    taxPrePaymentPerAxle,
    electronic,
    provia,
    electronicPricePerAxle,
    electronicTaxPrePaymentPerAxle,
    isExtraordinary,
    businessId
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollActivity(true));

      const toll = await createNewToll({
        name,
        description,
        addressId,
        locationId,
        pricePerAxle,
        taxPrePaymentPerAxle,
        electronic,
        provia,
        electronicPricePerAxle,
        electronicTaxPrePaymentPerAxle,
        isExtraordinary,
        businessId
      });

      if (toll && toll.id) {
        toastr.success('Éxito', 'El peaje fue creado correctamente');

        dispatch(push(`${TOLL_PATH}/${toll.id}`));
      }
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollActivity(false));
    }
  };

const putToll =
  (
    tollId,
    {
      name,
      description,
      addressId,
      locationId,
      pricePerAxle,
      taxPrePaymentPerAxle,
      electronic,
      provia,
      electronicPricePerAxle,
      electronicTaxPrePaymentPerAxle,
      isExtraordinary,
      businessId
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagTollActivity(true));

      const payload = {
        id: tollId,
        name,
        description,
        addressId,
        locationId,
        pricePerAxle,
        taxPrePaymentPerAxle,
        electronic,
        provia,
        electronicPricePerAxle,
        electronicTaxPrePaymentPerAxle,
        isExtraordinary,
        businessId
      };

      const url = `${TOLL_ENDPOINT}/${tollId}`;

      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);

      dispatch(push(`${TOLL_PATH}/${tollId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollActivity(false));
    }
  };

const deleteToll =
  ({ tollId }) =>
  async (dispatch) => {
    try {
      dispatch(flagTollActivity(true));

      const url = `${TOLL_ENDPOINT}/${tollId}`;

      const response = await fetch(url, DEFAULT_DELETE_CONFIG);

      await isErrorResponse(response, null, dispatch);

      toastr.success('Éxito', 'El peaje fue eliminado correctamente');

      dispatch(push(TOLL_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagTollActivity(false));
    }
  };

export {
  flagGettingTolls,
  getTolls,
  clearTolls,
  flagTollActivity,
  getToll,
  clearToll,
  createNewToll,
  postToll,
  putToll,
  deleteToll,
};
